export * from './auth.component';
